import { InsertItemResponse } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import {
	GetRecentPromotionCodeRecordResBody,
	SavePromotionCodeRecordDto,
} from '@src/type/promotion'

export async function savePromotionCodeRecord(saveDto: SavePromotionCodeRecordDto): Promise<void> {
	const res = await client.post<InsertItemResponse<Record<string, any>>>(
		'/promotion/record',
		saveDto,
	)

	if (res.data.success !== 1) {
		throw new Error('fail to save record')
	}
}

export async function getRecentPromotionCodeRecord(): Promise<GetRecentPromotionCodeRecordResBody> {
	const res = await client.get<GetRecentPromotionCodeRecordResBody>('/promotion/record/recent')

	if (res.data.success !== 1) {
		throw new Error('fail get recent record')
	}

	return res.data
}
